import { DateTime } from "luxon";

/** IANA zones offered wherever the console asks for one. */
export const TIMEZONES = [
  ["UTC", "UTC (Coordinated Universal Time)"],
  ["Asia/Kolkata", "IST (Indian Standard Time)"],
  ["America/New_York", "ET (Eastern Time)"],
  ["America/Los_Angeles", "PT (Pacific Time)"],
  ["Europe/London", "GMT (Greenwich Mean Time)"],
  ["Europe/Berlin", "CET (Central European Time)"],
  ["Asia/Shanghai", "CST (China Standard Time)"],
  ["Asia/Tokyo", "JST (Japan Standard Time)"],
  ["Australia/Sydney", "AEST (Australian Eastern Standard Time)"],
];

/** The browser's zone if we offer it, otherwise UTC. Beats defaulting everyone to UTC. */
export const defaultTimezone = () => {
  const local = DateTime.local().zoneName;
  return TIMEZONES.some(([z]) => z === local) ? local : "UTC";
};

/**
 * Interview slots are stored in GMT. A wall-clock ("2026-07-20T09:00") is meaningless
 * without the zone the user meant it in, so it's interpreted in `timezone` and converted.
 *
 * This is what the old Interview page did (moment.tz(...).tz("GMT")). Sending the raw
 * local time instead — which the console did until now — shifts every interview window by
 * the user's UTC offset: 5.5 hours out in IST.
 *
 * @returns {{start_date, end_date, start_time, end_time}} GMT, formatted as the API expects.
 */
export const toGmtSlotPayload = (localStart, localEnd, timezone) => {
  const start = DateTime.fromISO(localStart, { zone: timezone }).setZone("GMT");
  const end = DateTime.fromISO(localEnd, { zone: timezone }).setZone("GMT");

  return {
    start_date: start.toFormat("yyyy-MM-dd"),
    end_date: end.toFormat("yyyy-MM-dd"),
    // "HH:mm", not "HH:mm:ss" — matching the format the old page has always sent.
    start_time: start.toFormat("HH:mm"),
    end_time: end.toFormat("HH:mm"),
  };
};

/** Same wall-clock -> zone-aware instant, for validating against "now". */
export const inZone = (local, timezone) => DateTime.fromISO(local, { zone: timezone });
